module.exports = __webpack_public_path__ + "staticV3/img/baa35400.not-your-order.png";